export default __webpack_public_path__ + "static/media/ic-arrow-head-down.81b35b23.svg";